export function formatCurrency(number, currency = "EUR") {
    const CURRENCY_FORMATTER = new Intl.NumberFormat(undefined, {
        currency: currency,
        style: "currency",
    })
    return CURRENCY_FORMATTER.format(number)
}

export function centsToString(number) {
    const units = Math.trunc(number / 100)
    const cents = String(number % 100).padStart(2, "0")
    return `${units}.${cents}`
}

export function unitsToCents(number) {
    const numberString = String(number)
    if (numberString.includes(".")) {
        const split = numberString.split(".")
        const units = Number(split[0])
        const cents = split[1].length > 1 ? Number(split[1]) : Number(split[1]) * 10
        return units * 100 + cents
    } else {
        return Number(numberString) * 100
    }
}